<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import Form from "../components/form/Form.svelte";
  import Validators from "../utils/validators";
  import { headerDisplayStore, loadingStore } from "../stores/General";
  import { create, update, getById, getList } from "../api";
  import FormButtons from "../components/form/FormButtons.svelte";
  import PublisherDataList from "../components/form/PublisherDataList.svelte";
  import GenericButton from "../components/button/GenericButton.svelte";
  import changesStore from "../stores/Changes";
  import ActivateModal from "../components/modal/ActivateModal.svelte";
  import AutoCompleteCombo from "../components/form/AutoCompleteCombo.svelte";
  import InputWrapper from "../components/form/InputWrapper.svelte";
  import PlainInput from "../components/form/PlainInput.svelte";
  import RenderToggleButton from "../components/button/RenderToggleButton.svelte";
  import { Exclamation } from 'svelte-hero-icons';
  import SelectInput from "../components/form/SelectInput.svelte";

  export let id;

  const navigate = useNavigate();
  const module_name = "publisher";
  $: publisher = null;
  let publisher_types = [];
  const isUpdate = !!id;

  let channels = [];

  let adomains = [];
  let categories = [];
  
  /** @deprecated */
  let is_adomains_whitelist = false;
  /** @deprecated */
  let is_categories_whitelist = false;

  $: name = "";
  let max_creative_duration = 15;
  let publisher_type = "0";
  let publisher_deactivated = false;

  let showModal = false;
  let modalData = {};

  let form;
  let rules = {
    name: {
      validators: [
        Validators.required("Publisher Name is required"),
        Validators.minLength(3),
        Validators.exists(validateTextField, "Publisher Name already exists"),
      ],
    },
  };

  function ToggleActivate() {
    let data = {};

    data.deactivated = !publisher.deactivated;
    data.publisher_id = id;

    update(module_name, data)
      .then((response) => {
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Publisher saved successfully",
          });
          onCancel();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  //Function that takes a component to be rendered in the base modal and the action.
  function ToggleModal(action) {
    //modalData is an object sending all necessary data to the modal
    modalData.headerText = "Warning"
    modalData.Icon = Exclamation;
    if (action == "activate") {
      modalData.body = "Are you sure you want to activate the publisher?";
      modalData.rightButtonText = "Activate";
      modalData.rightButtonType = "success-solid";
    } else {
      modalData.body = "Are you sure you want to deactivate the publisher?";
      modalData.rightButtonText = "Deactivate";
      modalData.rightButtonType = "danger-solid";
    }
    showModal = !showModal;
  }

  async function getPublisher() {
    try {
      const res = await getById(module_name, id);
      publisher = res.publisher;

      if (!publisher) throw "no publisher returned";
      publisher_types = res.publisher_types.map((p) => ({
        value: p.id,
        label: p.name,
      }));
      publisher_type = publisher_types[+publisher.publisher_type] || "";
      name = publisher.name;
      max_creative_duration = publisher.max_creative_duration;
      channels = publisher.channels || [];
      // block_list = publisher.block_list || {
      (adomains = publisher?.block_list?.adomains || []),
        (categories = publisher?.block_list?.categories || []),
        (is_adomains_whitelist =
          publisher?.block_list?.is_adomains_whitelist || false),
        (is_categories_whitelist =
          publisher?.block_list?.is_categories_whitelist || false),
        // };
        // adomains = publisher.adomains || [];
        // categories = publisher.categories || [];
        (publisher_deactivated = publisher.deactivated);
    } catch (error) {
      console.log(error);
    }
  }

  async function getPublisherTypes() {
    try {
      const res = await getList("publisher/types", 10, 1, "name", "asc", {});
      const d = res.data.map((p) => ({ value: p.id, label: p.name }));
      return d;
    } catch (error) {
      headerDisplayStore.ShowError({
        title: "Failed to fetch publisher types",
      });
    }
  }

  onMount(async () => {
    loadingStore.on(module_name);
    if (id) {
      headerDisplayStore.SetTitle("Edit Publisher");
      await getPublisher();
    } else {
      publisher_types = await getPublisherTypes();
      headerDisplayStore.SetTitle("New Publisher");
    }
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "publisher",
        label: "Publisher",
      },
      {
        key: "new",
        label: "New",
      },
    ]);
    loadingStore.off();
  });

  function onTypeChange(event) {
    publisher_type = publisher_types[event.detail.value];
  }
  function onSubmit(e) {
    loadingStore.on(module_name, { disableGlobalIndicator: true });
    let { data:{adomains, categories, channels, ...data }} = e.detail;
    if (!name?.length) {
      loadingStore.off();
      headerDisplayStore.ShowError({
        title: "Error",
        subtitle: "Publisher name is missing",
      });
      return;
    }
    data.block_list = {
      adomains,
      categories,
      is_adomains_whitelist,
      is_categories_whitelist,
    };
    data.channels = $changesStore.channels;
    data.deactivated = publisher_deactivated;
    data.max_creative_duration = +data.max_creative_duration || 0;
    data.publisher_type = publisher_type?.value;
    data.name = name;

    if (data.publisher_id) {
      data.publisher_id = data.publisher_id.toString()
    }

    const send = id ? update : create;
    send(module_name, data)
      .then((response) => {
        loadingStore.off();
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Publisher saved successfully",
          });
          onCancel();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        loadingStore.off();
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }
  function onCancel() {
    changesStore.remove();
    navigate("/publisher");
  }

  async function validateTextField(name) {
    // name = e.detail.target.value;
    let page = 1;
    let sortBy = "name";
    let sortOrder = "ASC";
    let filter = { name };

    const { data } = await getList(
      module_name + "/exists",
      10,
      page,
      sortBy,
      sortOrder,
      filter
    ).catch((error) => {
      headerDisplayStore.ShowError({
        title: "Server error",
      });
    });
    // console.log(data, id);
    const count = data?.length || 0;
    if (count && data[0]?.publisher_id == id) {
      return [];
    }

    return data;
  }
</script>

<div class="max-w-full mx-auto py-6 px-4 sm:px-6 md:px-8 mb-10">
  {#if !id || publisher}
    <Form {rules} on:submit={onSubmit} bind:this={form}>
      <div class="bg-white p-8 w-full rounded-md">
        <div class="flex flex-row gap-2">
          <InputWrapper label="Publisher Name" name="name" required>
            <PlainInput
              bind:value={name}
              name="name"
              placeholder="Enter Publisher Name"
            />
          </InputWrapper>
          {#if id}
            <InputWrapper label="Publisher ID">
              <PlainInput bind:value={id} name="publisher_id" readonly />
            </InputWrapper>
          {/if}
        </div>
        <div class="flex flex-row gap-2 items-center mt-2">
          <InputWrapper label="Max Creative Duration">
            <PlainInput
              name="max_creative_duration"
              type="number"
              min={0}
              bind:value={max_creative_duration}
            />
          </InputWrapper>
          <InputWrapper label="Type">
            <SelectInput
              bind:value={publisher_type}
              items={publisher_types}
              isSearchable={false}
              isClearable={false}
              placeholder="Select Publisher Type"
              name="publisher_type"
              loadOptions={getPublisherTypes}
              on:select={(event) => onTypeChange(event)}
            />
          </InputWrapper>
        </div>
        <div class="text-md my-8 text-black font-bold">Channels</div>
        <PublisherDataList bind:channels name="channels" />
        <!-- {#if publisher?.publisher_id} -->
        <div class="w-full">
          <div class="text-md my-2 text-black font-bold">
            Advertiser Blocklist
          </div>
          <div class="text-sm mb-6 text-gray">
            Fields below will be combined as (Ad Domain OR Category)
          </div>
          <div class="grid grid-cols-2 gap-4 items-center mt-5 mb-10">
            <div class="h-full">
              <div class="flex flex-row text-sm">
                <div class="flex-initial">
                  <label
                    for={name}
                    class="grow strong w-full text-sm font-bold"
                  >
                    Ad Domain
                  </label>
                </div>
              </div>
              <AutoCompleteCombo
                bind:value={adomains}
                isMulti
                isUnknown
                isSelectAll
                entity="adomain_daily"
                name="adomains"
                placeholder="Select Ad Domains"
              />
            </div>
            <div class="h-full">
              <div class="flex flex-row text-sm">
                <div class="flex-initial">
                  <label
                    for={name}
                    class="grow strong w-full text-sm font-bold"
                  >
                    Blocklist Category
                  </label>
                </div>
              </div>
              <AutoCompleteCombo
                bind:value={categories}
                isMulti
                isUnknown
                isSelectAll
                entity="categories"
                name="categories"
                placeholder="Select Categories"
              />
              <!-- <SingleCheckbox
                label="Categories Whitelist"
                name="is_categories_whitelist"
                bind:value={is_categories_whitelist}
              /> -->
            </div>
          </div>
        </div>
        <!-- <PublisherBlockList bind:block_list name="block_list" /> -->
        <!-- {/if} -->

        <div class="flex flex-row justify-between mt-2">
          {#if id}
            {#if publisher.deactivated}
              <GenericButton
                text="Activate"
                buttonTheme="success-light"
                onClick={() => {
                  ToggleModal("activate");
                }}
              />
            {:else}
              <GenericButton
                text="Deactivate"
                buttonTheme="danger-light"
                onClick={() => {
                  ToggleModal("deactivate");
                }}
              />
            {/if}
          {/if}
        </div>
      </div>
      <FormButtons {isUpdate} on:cancel={onCancel} />
      {#if showModal}
        <ActivateModal
          on:click={ToggleModal}
          {modalData}
          on:modalSubmit={ToggleActivate}
        />
      {/if}
    </Form>
  {/if}
</div>
